import { BUISNESS_FUNCTION_PATH, useBuisnessFunctionRoute } from './routing';
import BuisnessFunctionListPage from './List';
import { Page404 } from 'framework/statusPages';
import { ProtectedRouter } from 'infrastructure/routing';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { Routes, Route } from 'react-router-dom';

const BuisnessFunctionRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useBuisnessFunctionRoute();

  return (
    <ProtectedRouter basePath={BUISNESS_FUNCTION_PATH}>
      <Routes>
        <Route
          path={listRoute}
          element={
            // TODO Use GlobalProtectedRoute
            <BuisnessFunctionListPage />
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

BuisnessFunctionRouter.getRouterPath = () => `${BUISNESS_FUNCTION_PATH}/*`;

export default BuisnessFunctionRouter;
